import { gql } from 'apollo-boost';
import { useMutation } from '@apollo/react-hooks';
import { useDispatch } from 'react-redux';
import { delAuthUser } from '../utils/storage';
import { delAuthToken } from '../utils/authService';
import { removeClient } from '../store/sharedStore/actions';

const LOGOUT = gql`
  mutation Logout {
    logout {
      ok
    }
  }
`;

function useLogout() {
  const dispatch = useDispatch();
  const [logoutMutation] = useMutation(LOGOUT);

  return async function logout() {
    try {
      await logoutMutation();
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    } finally {
      delAuthUser();
      delAuthToken();
      localStorage.clear();
      dispatch(removeClient());
      window.location.href = '/';
    }
  };
}

export default useLogout;
